/* AUDIONIS — sticky add-to-cart bar
   Shows a fixed bar with the price and an Add to cart button once the real
   Add to cart button scrolls out of view (mobile). */
(function () {
  var bar = document.querySelector('[data-an-sticky-atc]');
  var realButton = document.querySelector('.product-form__submit');
  if (!bar || !realButton) return;

  var submitButton = bar.querySelector('[data-an-sticky-atc-submit]');
  var priceTarget = bar.querySelector('[data-an-sticky-atc-price]');
  var priceSource = document.querySelector(
    '.product__info-wrapper .price, .product__info-container .price, .price--large'
  );

  // Show / hide the bar as the real Add to cart button enters or leaves the viewport
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting;
          bar.hidden = !visible;
          bar.classList.toggle('is-visible', visible);
        });
      },
      { rootMargin: '-90px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(realButton);
  }

  // Keep the price in the bar in sync when the customer changes variant
  if (priceSource && priceTarget && 'MutationObserver' in window) {
    var priceObserver = new MutationObserver(function () {
      priceTarget.innerHTML = priceSource.innerHTML;
    });
    priceObserver.observe(priceSource, { childList: true, subtree: true, characterData: true });
  }

  // Mirror the sold-out / loading state of the real button
  var stateObserver = new MutationObserver(function () {
    submitButton.disabled = realButton.disabled || realButton.getAttribute('aria-disabled') === 'true';
  });
  stateObserver.observe(realButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

  // Tapping the bar's button triggers the real Add to cart
  submitButton.addEventListener('click', function () {
    if (realButton.disabled || realButton.getAttribute('aria-disabled') === 'true') return;
    realButton.click();
    realButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
